<template>
  <!-- eslint-disable vue/no-multiple-template-root -->
  <Header />
  <router-view :key="$route.fullPath"></router-view>
  <MonTargetDetailPopup
    v-if="popup.detail.show"
    :params="popup.detail.param"
    :dateTime="popup.detail.param.isEventDetail ? searchDateDashboard : null"
    :isApp="popup.detail.param.isEventDetail"
    @close="togglePopup('detail')"
  ></MonTargetDetailPopup>
  <MonTargetEventDetailPopup
    v-if="isEventDetailPopup"
    :params="modalParam"
    pTitle="이벤트 상세"
    @close="popupClose"
  />
  <authorization-check-result-modal
    v-for="result in authorizationCheckResult"
    :result="result"
    :key="result.id"
  />
  <canvas id="canvas" style="position: absolute; top: 0px; visibility: hidden"></canvas>
</template>

<script>
import Header from './containers/main/Header';
import MonTargetDetailPopup from '@/containers/popup/MonTargetDetailPopup.vue';
import MonTargetEventDetailPopup from '@/containers/popup/MonTargetEventDetailPopup.vue';
import AuthorizationCheckResultModal from '@/containers/components/messagePopup/AuthorizationCheckResultModal.vue';
import { chunk } from 'lodash';
import { mapState } from 'vuex';

export default {
  name: 'App',
  components: {
    Header,
    MonTargetDetailPopup,
    MonTargetEventDetailPopup,
    AuthorizationCheckResultModal
  },
  computed: {
    ...mapState({
      searchDateDashboard: (state) => state.dashboardState.searchDateDashboard
    }),
    authorizationCheckResult() {
      return this.$store.getters['authStore/authorizationCheckResult'];
    },
    notificationItems() {
      return this.$store.getters['notify/notificationItems'];
    },
    notificationInternalId() {
      return this.$store.getters['notify/internalId'];
    }
  },
  watch: {
    notificationItems(newItems) {
      newItems.length && this.showToastByChunk(newItems);
    }
  },
  data() {
    return {
      popup: {
        detail: {
          show: false,
          param: null
        }
      },
      isEventDetailPopup: false,
      modalParam: {}
    };
  },
  methods: {
    showDetailPopup(param) {
      this.togglePopup('detail', param);
    },
    closeDetailPopup() {
      this.popup.detail.show = false;
    },
    togglePopup(id, param) {
      this.$store.commit('setProjectSelected', param);
      if (param != null) this.popup[id].param = param;
      this.popup[id].show = !this.popup[id].show;
    },
    changeLocale() {
      this.$i18n.locale = this.getLocale();
    },
    setLanguage(language) {
      let convertLanguage = language;
      if (this.isEmpty(language)) {
        // session 에서 language 정보가 없는 경우에 default 값 적용
        convertLanguage =
          window.localStorage.getItem('language') || navigator.language || navigator.userLanguage;
      }
      // TODO: bss 에서는 ko_KR 로 전달, api g/w 에서는 ko-KR 로 전달
      if (convertLanguage === 'ko-KR') {
        localStorage.setItem('language', 'ko_KR');
      } else if (convertLanguage === 'en-US') {
        localStorage.setItem('language', 'en_US');
      } else {
        localStorage.setItem('language', convertLanguage);
      }
    },

    getLocale() {
      return (
        window.localStorage.getItem('language') ||
        navigator.language ||
        navigator.userLanguage
      ).substring(0, 2);
    },
    // 이벤트 데이타조회
    async searchEvent(item) {
      let param = {
        eventState: 'ALL',
        metricKey: item.metricKey,
        queryStartDt: item.startDt,
        eventLevel: item.productEventLevel
      };
      const payload = {
        productResourceId: item.productResourceId,
        productTypeCode: item.productTypeCode,
        param,
        listDataCheckAuth: [
          { productResourceId: item.productResourceId, productName: item.productName }
        ]
      };

      await this.$store.dispatch('authStore/checkProductEventLevel', payload).then((res) => {
        if (res.type === this.$const.AuthorizationResult.ALLOW) {
          const data = res.responseData;
          if (this.$util.isNotEmpty(data)) {
            if (data.totalCount > 0) {
              let objEvent = data.contents.find((v) => {
                return (
                  ['FATAL', 'WARNING'].includes(item.eventLevel) &&
                  v.eventId == item.eventId &&
                  v.eventLevel == item.eventLevel &&
                  v.startDt == item.startDt
                );
              });
              if (typeof objEvent == 'undefined') {
                this.policyId = data.contents[0].eventPolicyId;
                this.startDt = data.contents[0].startDt;
                this.eventId = data.contents[0].eventId;
              } else {
                this.policyId = objEvent.eventPolicyId;
                this.startDt = objEvent.startDt;
                this.eventId = objEvent.eventId;
              }
              this.showDetailPopup(item);
            }
          }
        }
      });
    },
    openEventDetailmodal(item) {
      this.modalParam = {
        productId: item.productId,
        productResourceId: item.productResourceId,
        productTypeCode: item.productTypeCode,
        productName: item.productName,
        eventId: (this.eventId || '') == '' ? item.eventId : this.eventId,
        policyId: (this.policyId || '') == '' ? item.eventPolicyId : this.policyId,
        startDate: (this.startDt || '') == '' ? item.startDt : this.startDt,
        projectId: item.projectId
      };
      this.isEventDetailPopup = true;
      this.policyId = null;
      this.startDt = null;
      this.eventId = null;
    },

    popupClose() {
      this.isEventDetailPopup = false;
    },

    showNotificationItems(newItems) {
      if (!newItems || !newItems.length) return;
      newItems.forEach((item) => {
        const name = item.name.length > 35 ? item.name.slice(0, 35) + '...' : item.name;
        this.$toast.open(this.$t(item.langKey, [name]));
      });
      this.$store.dispatch('notify/markNotificationAsRead', newItems);
    },

    showToastByChunk(items = [], timeOut = 5000, chunkSize = 5) {
      if (items.length <= chunkSize) {
        this.showNotificationItems(items);
        return;
      }

      let indexChunk = 0;
      const chunkItems = chunk(items, chunkSize);
      clearInterval(this.notificationInternalId);

      this.showNotificationItems(chunkItems[indexChunk++]);

      const chunkNotificationId = setInterval(() => {
        this.showNotificationItems(chunkItems[indexChunk++]);
      }, timeOut);

      this.$store.dispatch('notify/updateChunkNotificationId', chunkNotificationId);

      setTimeout(() => {
        this.$store.dispatch('notify/needCheckNotifications', true);
      }, timeOut * (chunkItems.length - 1) + 1000);
    }
  },
  created() {
    this.changeLocale();
  },
  beforeCreate() {
    window.app = this;
  },
  mounted() {
    this.$store.dispatch('notify/setNotificationsInterval');
    this.$store.dispatch('productType/setProductTypeGroups');
  }
};
</script>

<style>
body {
  height: 100% !important;
  min-height: 100%;
}

#app {
  position: relative;
  height: 100%;
  min-width: 1920px;
  min-height: 840px;
}
</style>
